var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompared(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,1L9,1L9,2L13,2C14.1046,2,15,2.89543,15,4L15,12C15,13.1046,14.1046,14,13,14L9,14L9,15L7,15L7,14L3,14C1.8954309999999999,14,1,13.1046,1,12L1,4C1,2.89543,1.8954309999999999,2,3,2L7,2L7,1ZM9,12.5L13,12.5C13.2455,12.5,13.4496,12.3231,13.4919,12.0899L13.5,12L13.5,4C13.5,3.75454,13.3231,3.55039,13.0899,3.50806L13,3.5L9,3.5L9,12.5Z",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompared);
export default __webpack_public_path__ + "static/media/compared.86dc342b.svg";
export { ForwardRef as ReactComponent };